import "./Activity.css";
import { useEffect, useState } from "react";
import { api } from "../../api/client";
import Loader from "../../components/Loader/Loader";

function fmt(ts) {
  return new Date(ts).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export default function Activity() {
  const [rows, setRows] = useState(null);
  const [actorFilter, setActorFilter] = useState("");

  useEffect(() => {
    api.get("/admin/audit").then(setRows);
  }, []);

  if (!rows) return <Loader inline />;

  const filtered = actorFilter
    ? rows.filter((r) => (r.actorEmail || "").toLowerCase().includes(actorFilter.toLowerCase()))
    : rows;

  return (
    <div className="activity-page col">
      <h1 className="t-h1">Activity</h1>
      <input
        className="activity-filter"
        type="text"
        placeholder="Filter by actor email"
        value={actorFilter}
        onChange={(e) => setActorFilter(e.target.value)}
      />
      <ul className="activity-list col">
        {filtered.map((row) => (
          <li key={row.id} className={`activity-row col activity-row-${row.result}`}>
            <div className="row activity-row-top">
              <span className="t-mono t-dimmer">{fmt(row.happenedAt)}</span>
              <span className={`activity-result activity-result-${row.result}`}>{row.result}</span>
            </div>
            <span className="t-label">{row.action}</span>
            <span className="t-body-sm t-dim">
              {row.actorEmail || row.actorId || "unknown"} · {row.subjectLabel || row.subject}
            </span>
          </li>
        ))}
        {!filtered.length ? <p className="t-body-sm t-dimmer">No activity yet.</p> : null}
      </ul>
    </div>
  );
}
